import React from 'react'
import PropTypes from 'prop-types'
import {useModalContext} from './modalContext'

export const ModalTrigger = ({children, attributes}) => {
    const {setModalOpen} = useModalContext()
    return (
        <button onClick={() => setModalOpen(true)} {...attributes}>
            {children}
        </button>
    )
}

ModalTrigger.propTypes = {
    attributes: PropTypes.object.isRequired,
    children: PropTypes.node
}

export const ModalTriggerDefinition = {
    component: ModalTrigger,
    name: 'ModalTrigger',
    noWrap: true,
    hideFromInsertMenu: true,
    canHaveChildren: true
}
